import { Injectable, OnDestroy } from '@angular/core';
import { ApiService, RefDto } from './api.service';
import { Subscription, BehaviorSubject, Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { ItemDto } from 'src/app/core/services/api.service';

@Injectable()
export class TexteService implements OnDestroy {

  constructor(private apiService: ApiService) {
    this.texteSubscription.push(this.langue.subscribe(() => { this.loadTextes().subscribe(); }));
  }

  private texteSubscription: Subscription[] = [];
  private langue: BehaviorSubject<ItemDto> = new BehaviorSubject(null);
  private langues: ItemDto[];
  private Textes: RefDto[];

  public readonly Langue: Observable<ItemDto> = this.langue.asObservable();

  ngOnDestroy(): void {
    this.texteSubscription.forEach(sub => sub.unsubscribe());
  }

  public selectLangue(code: string) {
    const l = this.langues.find(langue => langue.code === code);
    this.langue.next(l);
  }

  public loadLangues(): Observable<boolean> {
    return this.apiService.getLangues().pipe(
      map(data => {
      this.langues = data;
      return true;
    }),
    catchError(() => {
      return of(false);
    }));
  }

  public loadTextes(): Observable<boolean> {
    if (this.langue.value != null) {
      return this.apiService.getTexteByLangue(this.langue.value.id).pipe(
        map(res => {
          this.Textes = res;
          return true;
        }),
        catchError(() => {
          return of(false);
        }));
    } else {
      return of(false);
    }
  }

  public getTexte(code: string, subText: string = ''): string {
    if (this.Textes == null) { return ''; }
    const txt = this.Textes.find(t => t.code === code);
    return txt != null ? txt.libelle : subText;
  }
}
